import React from 'react';
import { useNavigate } from 'react-router-dom';

const KVKKPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: '1px solid #d1d5db', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 14, color: '#374151' }}>
          ← Geri
        </button>
        <div>
          <div style={{ fontWeight: 700, color: '#111827', fontSize: 16 }}>Türkiye Siber Güvenlik Kümelenmesi</div>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Staj Platformu · KVKK Aydınlatma Metni</div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 24px 64px' }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#111827', marginBottom: 8 }}>
          Kişisel Verilerin Korunması Hakkında Aydınlatma Metni
        </h1>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 32 }}>
          Son güncelleme: Mayıs 2026 · 6698 sayılı KVKK kapsamında hazırlanmıştır.
        </p>

        {[

          {
            title: '2. İşlenen Kişisel Veriler',
            content: null,
            list: [
              'Kimlik bilgileri: ad, soyad, doğum tarihi, cinsiyet, uyruk, askerlik durumu',
              'İletişim bilgileri: e-posta adresi, telefon numarası, şehir',
              'Eğitim bilgileri: üniversite, bölüm, sınıf, GPA, mezuniyet yılı',
              'Mesleki bilgiler: teknik beceriler, sertifikalar, iş/staj deneyimleri, projeler, yayınlar',
              'Platform profil bilgileri: LinkedIn, GitHub, kişisel web sitesi, Twitter/X bağlantıları',
              'CV belgesi: yüklenen PDF dosyası ve içeriğinden çıkarılan metin',
              'Güvenlik bilgileri: şifrelenmiş parola, iki faktörlü kimlik doğrulama (2FA) ayarları',
              'Kullanım verileri: giriş kayıtları, başvuru geçmişi, bildirim verileri',
            ],
          },
          {
            title: '3. Kişisel Verilerin İşlenme Amaçları',
            content: null,
            list: [
              'Staj başvuru süreçlerinin yürütülmesi ve öğrenci–şirket eşleştirmesinin yapılması',
              'Kullanıcı hesabının oluşturulması ve kimlik doğrulamasının sağlanması',
              'Şirketlerin uygun aday havuzuna erişiminin sağlanması',
              'Platform güvenliğinin korunması ve yetkisiz erişimin önlenmesi',
              'Yasal yükümlülüklerin yerine getirilmesi',
              'İstatistiksel analizler ve platform iyileştirme çalışmaları (anonim)',
            ],
          },
          {
            title: '4. Kişisel Verilerin Aktarımı',
            content: `Kişisel verileriniz; platformda kayıtlı şirketlerle (yalnızca başvuru veya davet sürecinde profiliniz ve CV'niz), yasal zorunluluk hâlinde yetkili kamu kurum ve kuruluşlarıyla paylaşılabilir. Verileriniz yurt dışına aktarılmamaktadır.`,
          },
          {
            title: '5. Kişisel Verilerin Saklanma Süresi',
            content: `Kişisel verileriniz hesabınız aktif olduğu sürece saklanır. Hesabınızı silmeniz hâlinde verileriniz 30 gün içinde sistemden kalıcı olarak silinir. Yasal yükümlülükler kapsamında saklanması gereken veriler ilgili mevzuatta öngörülen süreler boyunca tutulur.`,
          },
          {
            title: '6. Kişisel Verilerin Korunmasına İlişkin Teknik Tedbirler',
            content: null,
            list: [
              'Tüm iletişim TLS/SSL şifrelemesi ile korunmaktadır',
              'İsteğe bağlı iki faktörlü kimlik doğrulama (2FA/TOTP) sunulmaktadır',
              'Erişim logları ve denetim kayıtları tutulmaktadır',
              'Veriler Türkiye\'de bulunan sunucularda saklanmaktadır',
            ],
          },
          {
            title: '7. KVKK Kapsamındaki Haklarınız',
            content: `6698 sayılı KVKK\'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:`,
            list: [
              'Kişisel verilerinizin işlenip işlenmediğini öğrenme',
              'İşlenmişse buna ilişkin bilgi talep etme',
              'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme',
              'Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme',
              'Eksik veya yanlış işlenmişse düzeltilmesini isteme',
              'Kanun\'da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme',
              'Otomatik sistemler aracılığıyla aleyhinize sonuç doğuran kararlara itiraz etme',
              'Kanuna aykırı işleme nedeniyle zararın giderilmesini talep etme',
            ],
          },
          {
            title: '8. Başvuru Yolu',
            content: `Haklarınızı kullanmak için platform üzerindeki "Verilerim (KVKK)" bölümünden veri silme talebinde bulunabilir veya info@siberkume.com adresine e-posta gönderebilirsiniz. Talepler en geç 30 gün içinde yanıtlanır.`,
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid #f3f4f6' }}>
              {section.title}
            </h2>
            {section.content && (
              <p style={{ fontSize: 14, color: '#374151', lineHeight: 1.7, margin: 0 }}>
                {section.content}
              </p>
            )}
            {section.list && (
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                {section.list.map((item, j) => (
                  <li key={j} style={{ fontSize: 14, color: '#374151', lineHeight: 1.7, marginBottom: 4 }}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}

        <div style={{ marginTop: 40, padding: 20, background: '#eff6ff', borderRadius: 10, border: '1px solid #bfdbfe' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#1d4ed8', marginBottom: 4 }}>İletişim</div>
          <div style={{ fontSize: 13, color: '#1e40af' }}>
            Türkiye Siber Güvenlik Kümelenmesi · info@siberkume.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default KVKKPage;
